// extracted by mini-css-extract-plugin
module.exports = {"teclaContainer":"Tecla_teclaContainer__1033k"};